export default "__VITE_PUBLIC_ASSET__e3b85fd9__"